import { EventEmitter, Injectable } from '@angular/core';
import { LeadComposerChangesModel } from "../../../../models/leads/leads.model";
import { ComposerOfferOrOrder } from "../../../../models/action.model";

@Injectable({
  providedIn: 'root'
})
export class OrderOfferTransferService {

  static isMobile: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  static isClosed: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  static composerOffers: EventEmitter<LeadComposerChangesModel[]> = new EventEmitter<LeadComposerChangesModel[]>();
  static composerOrders: EventEmitter<LeadComposerChangesModel[]> = new EventEmitter<LeadComposerChangesModel[]>();
  static closePopup: EventEmitter<boolean> = new EventEmitter<boolean>();
  static openOrdersAndOffersPopup: EventEmitter<boolean> = new EventEmitter<boolean>();
  static loadComposerOffers: EventEmitter<ComposerOfferOrOrder> = new EventEmitter<ComposerOfferOrOrder>();
  static selectedLeadHistory: any

  constructor() {
  }
}
